import { render, staticRenderFns } from "./SfProductCardHorizontalSkeleton.vue?vue&type=template&id=2eb3beea&scoped=true&"
import script from "./SfProductCardHorizontalSkeleton.vue?vue&type=script&lang=ts&"
export * from "./SfProductCardHorizontalSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./SfProductCardHorizontalSkeleton.vue?vue&type=style&index=0&id=2eb3beea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb3beea",
  null
  
)

export default component.exports